<div class="localization-container-buttons">
    <button type="button" *ngFor="let language of this.languages$ | async" (click)="changeLanguage(language)"
            [ngClass]="'button-language '+language" [class.active]="language===this.cataleanLocalizationService.ActiveLanguage">
        {{language | uppercase | slice:0:2}}
    </button>
</div>
